import { type FooterVariant, resolveFooterVariant } from 'src/lib/site-footer';
import {
  type NavigationVariant,
  resolveSiteNavigation,
} from 'src/lib/site-navigation';
import { HOMEPAGE_EVENTS } from 'src/lib/trackingEvents';
// TODO: make this global?
const getPreloadedImages = (fields) => {
  if (fields?.backgroundImage) {
    return {
      preloadImages: [
        {
          src: fields?.backgroundImage?.fields?.file?.url || '',
        },
      ],
    };
  }
  return {};
};

type Image = {
  src: string;
};

interface IMetadataAdapter {
  'meta-title': string;
  'meta-description': string;
  noIndex: boolean;
  preloadImages?: Array<Image>;
  hasFooter: boolean;
  hasFooterCta: boolean;
  openGraphImage?: string;
  structuredData?: object | Array<object>;
  canonicalPagePath?: string;
}

// TODO: make this global?
export const mainTemplateMetaTagAdapter = ({ fields }): IMetadataAdapter => {
  return {
    'meta-description': fields?.metaDescription || '',
    'meta-title': fields?.metaTitle || '',
    hasFooter: true,
    hasFooterCta: fields?.footerCta || false,
    noIndex: fields?.blockSearchIndexing || false,
    openGraphImage: fields?.openGraphImage?.fields?.file?.url || '',
    structuredData: fields?.structuredData,
    canonicalPagePath: fields.canonicalUrl
      ? `/${fields.canonicalUrl.join('/')}/` // [ 'foo', 'bar' ] -> '/foo/bar/'
      : undefined,
    ...getPreloadedImages(fields),
    // TODO: locale
  };
};

export const mainTemplateNavigationAdapter = ({
  fields,
}): {
  hasNavigation: boolean;
  navigationVariant: NavigationVariant;
} => {
  const siteNavigation = resolveSiteNavigation(fields);
  return {
    hasNavigation: siteNavigation !== 'Hidden',
    navigationVariant: siteNavigation === 'Minimal' ? 'minimal' : 'default',
  };
};

export const mainTemplateFooterAdapter = ({
  fields,
}): { footerVariant: FooterVariant } => {
  return {
    footerVariant: resolveFooterVariant(fields),
  };
};

const getBackgroundImage = (fields) => {
  if (fields?.backgroundImage?.fields?.file?.url) {
    return {
      backgroundImage: `url('${fields?.backgroundImage?.fields?.file?.url.replace(
        /\?(.+)/,
        '?fm=webp&q=1', // we don't set a width since we do not know the size of the uploaded image
      )}')`,
    };
  }
  return {};
};

// TODO: type this
export const mainTemplateStylesAdapter = ({ fields }) => {
  return {
    sx: {
      ...getBackgroundImage(fields),
      backgroundRepeat: 'no-repeat',
      bgcolor: fields?.backgroundColor?.fields.color || 'white',
      ...(fields?.styles || {}),
    },
    navbarStyles: {
      sx: { bgcolor: fields?.backgroundColor?.fields.color || 'white' },
    },
  };
};

export const homepageMetadataAdapter = () => {
  return {
    excludeBrandFromMetaTitle: true,
    getStartedTrackingId: HOMEPAGE_EVENTS.GET_API_KEYS.FOOTER,
    contactSalesTrackingId: HOMEPAGE_EVENTS.CONTACT_SALES.FOOTER,
    structuredData: {
      '@context': 'https://schema.org',
      '@type': 'Organization',
      url: 'https://plaid.com/',
      logo: 'https://plaid.com/assets/img/navbar/logo--is-white.svg',
      address: {
        '@type': 'PostalAddress',
        addressLocality: 'San Francisco',
        addressRegion: 'CA',
        streetAddress: '1098 Harrison St.',
      },
      name: 'Plaid',
      sameAs: [
        'https://www.linkedin.com/company/plaid-/',
        'https://twitter.com/plaid',
        'https://www.instagram.com/plaid/',
        'https://en.wikipedia.org/wiki/Plaid_(company)',
      ],
    },
  };
};
